module.exports = __webpack_public_path__ + "media/contractor-reporting/who-turned-up-f16e1488.png";